import { Reveal } from "../motion/Reveal";
import { VALUES, IMAGES } from "../../data/content";

export const Values = () => {
  return (
    <section id="values" className="relative py-24 md:py-36 bg-ink-soft/40 border-y border-white/10">
      <div className="container-editorial">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="overline mb-6">04 — Life Values</p>
              <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-bone">
                Principles Beyond <br /> the <span className="italic text-gold">Charts.</span>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <p className="text-ash leading-relaxed">
                Professional achievement and personal character are inseparable. These are the
                values that hold everything together.
              </p>
            </Reveal>
          </div>
        </div>

        {/* Values grid with an image cell */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {VALUES.slice(0, 4).map((v, i) => (
            <ValueCell key={v} value={v} index={i} />
          ))}

          {/* image cell spanning 2 cols */}
          <div className="col-span-2 row-span-1 relative overflow-hidden bg-ink min-h-[180px] group">
            <img
              src={IMAGES.lifestyleSelfie}
              alt="Dakka Gabriel Rey"
              className="absolute inset-0 h-full w-full object-cover contrast-[1.05] saturate-[1.08] transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-ink/40" />
          </div>

          {VALUES.slice(4).map((v, i) => (
            <ValueCell key={v} value={v} index={i + 4} />
          ))}
        </div>

        {/* highlighted quote */}
        <Reveal y={50}>
          <div className="mt-16 md:mt-24 text-center max-w-4xl mx-auto">
            <span className="font-serif text-6xl text-gold/40 leading-none">“</span>
            <p className="font-serif text-3xl md:text-5xl leading-[1.15] tracking-tight text-bone -mt-6">
              Success is not only measured by what we gain, but by{" "}
              <span className="italic text-gold">who we become</span> through the process.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

const ValueCell = ({ value, index }) => (
  <div
    data-testid={`value-cell-${index}`}
    className="group relative bg-ink p-8 min-h-[180px] flex flex-col justify-between transition-colors duration-500 hover:bg-white/[0.03]"
  >
    <span className="font-mono text-xs text-ash group-hover:text-gold transition-colors">
      {String(index + 1).padStart(2, "0")}
    </span>
    <h3 className="font-serif text-2xl md:text-3xl text-bone group-hover:text-gold transition-colors duration-300 tracking-tight">
      {value}
    </h3>
  </div>
);
